import React, { useEffect, useState } from 'react';
import { getAppEnv } from '../../../config/env';
import AutoComplete from '../CabModifySearch/CabAutoComplete';
import { getPlaceObject } from '../../utils/reverseGeoCode';
import { SetFromPlace } from '../../types';
import { isInvalidMultiStopForMobile, Stop, travelForMap } from './util';
import useOutsideClick from '../CabModifySearch/useOutsideClick';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

interface MultiCityMobileProps {
  widget: number | null;
  travelFor: string;
  setMobileStops: (mobileStops: Stop[]) => void;
  mobileStops: Stop[];
  fromCity: string;
  toCity: string;
  dayDifference: number;
}

const MultiCityMobile = ({
  widget,
  travelFor,
  setMobileStops,
  mobileStops,
  fromCity,
  toCity,
  dayDifference
}: MultiCityMobileProps) => {
  const [showToolTip, setShowToolTip] = useState(false);
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [stopIndex, setStopIndex] = useState<number | null>(null);
  const [isInvalidStops, setIsInvalidStops] = useState(true);
  const tooltipRef = useOutsideClick(() => {
    setShowToolTip(false);
  });

  useEffect(() => {
    if (mobileStops?.length > 0) {
      setIsInvalidStops(isInvalidMultiStopForMobile(mobileStops));
    }
  }, [mobileStops]);

  const stopsCrud = (
    operationType: 'add' | 'update' | 'delete',
    value?: Stop,
    index?: number
  ) => {
    switch (operationType) {
      case 'add':
        setMobileStops([
          ...mobileStops,
          {
            label: value?.label || '',
            city: value?.city || '',
            state: value?.state || '',
            placeId: value?.placeId || ''
          }
        ]);
        break;
      case 'update':
        if (index !== undefined && value) {
          const updatedStops = mobileStops?.map((stop, i) =>
            i === index ? { ...stop, ...value } : stop
          );
          setMobileStops(updatedStops);
        }
        break;
      case 'delete':
        if (index !== undefined) {
          let filteredStops = mobileStops?.filter((_, i) => i !== index);
          filteredStops = filteredStops?.map((stop, i) => ({
            ...stop,
            label: `Stop ${i + 1}`
          }));
          setMobileStops(filteredStops);
        }
        break;
      default:
        break;
    }
  };

  const onLocationChange = async (
    city: string,
    stn: string,
    placeId: string
  ) => {
    const placeObject = await getPlaceObject(placeId);
    closePopup();
    const newStopObject = {
      label: `Stop ${stopIndex != null ? stopIndex + 1 : ''}`,
      city: city || '',
      state: stn || '',
      placeId: placeId || ''
    };
    if (stopIndex !== null) {
      stopsCrud('update', newStopObject, stopIndex);
    }
  };

  const renderMultiStopsMobile = () => {
    return mobileStops?.map((stop, idx) => {
      return (
        <div className="makeFlex spaceBetween fullWidth hrtlCenter">
          <div
            className={`rsw_inputBox width90${
              widget !== null ? `inactiveWidget` : ``
            } ${idx === 4 ? 'appendBottom16' : ''}`}
            onClick={() => {
              setShowAutoComplete(true);
              setStopIndex(idx);
            }}
          >
            <div className="stopIconMake appendRight8">
              <div className="stopLine whiteBackGroundColor">
                <div className="stopCircle whiteBackGroundColor"></div>
              </div>
            </div>
            <div className="stopsContainer">
              <label className="lbl_input latoBold makeFlex column loaderOnClick">
                <span
                  className={`${
                    stop?.city ? `appendBottom5` : ``
                  } font12 capText deepskyBlueText`}
                >
                  {stop?.label}
                </span>
                <div className="makeFlex">
                  <p className="rsw_inputField font16 whiteText">
                    {stop?.city}
                  </p>
                  <span className="appendLeft5 appendTop3 font12 whiteText latoRegular">
                    {stop?.state}
                  </span>
                </div>
              </label>
            </div>
          </div>
          <div
            onClick={() => stopsCrud('delete', undefined, idx)}
            className="crossIconWrapper cursorPointer"
          >
            <img
              src={`${PUBLIC_URL}/static/public/cross_img.png`}
              height={'24px'}
              width={'24px'}
              alt="crossIcon"
            />
          </div>
        </div>
      );
    });
  };

  const closePopup = () => {
    setShowAutoComplete(false);
  };

  return (
    <>
      {mobileStops?.length > 0 && !isInvalidStops && (
        <p className="font12 whiteText appendTop5 appendBottom5">
          {travelForMap[travelFor] ? travelForMap[travelFor] : ''} :{' '}
          {`${dayDifference > 1 ? `${dayDifference} days` : `1 day`}`} |
          {fromCity && toCity && fromCity?.trim() && toCity?.trim() && (
            <>
              {` ${fromCity} → `}
              {mobileStops?.map((stop, idx) => (
                <span key={idx}>{stop?.city ? `${stop?.city} → ` : ``}</span>
              ))}
              {`${toCity}`}
              {travelFor === 'Outstation Round-trip' && ` → ${fromCity}`}
            </>
          )}
        </p>
      )}
      {renderMultiStopsMobile()}
      {mobileStops?.length < 5 && (
        <div className="addStopWrapper appendTop10 appendBottom10 makeFlex hrtlCenter">
          <button
            className="addStopBtn"
            onClick={() =>
              stopsCrud('add', {
                label: `Stop ${mobileStops?.length + 1}`,
                city: '',
                state: '',
                placeId: ''
              })
            }
          >
            {mobileStops?.length > 0 ? 'Add More Stops' : 'Add Stops'}
            <img
              src={`${PUBLIC_URL}/static/public/new_tag.png`}
              className="newImage"
              height={'16px'}
              width={'30px'}
            />
          </button>
          <div className="relative tooltipItem">
            <img
              onClick={() => setShowToolTip(true)}
              src={`${PUBLIC_URL}/static/public/infoIc.png`}
              height={'16px'}
              width={'16px'}
              alt="infoIc"
              className="appendLeft5 vertAlignBottom"
            />
            {showToolTip && (
              <span ref={tooltipRef} className="tooltipContainer">
                <div className="tooltipText">
                  You can add one or more stops in same or other cities
                </div>
                <img
                  onClick={() => setShowToolTip(false)}
                  src={`${PUBLIC_URL}/static/public/close_grey.webp`}
                  height={'20px'}
                  width={'20px'}
                  alt="infoIc"
                />
              </span>
            )}
          </div>
        </div>
      )}
      {showAutoComplete && (
        <div className="mcAutoSuggest">
          <AutoComplete
            autoFocus={true}
            travelFor={travelFor}
            placeholder={'Enter stop'}
            closeCityPopup={closePopup}
            onChange={onLocationChange}
            widget={0}
          />
        </div>
      )}
    </>
  );
};

export default MultiCityMobile;
